import React, { useRef } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useDrag, useDrop } from "react-dnd";

import {
  setEditQuestion,
  rearrangeItems,
  resetIds
} from '../../../../../../_actions/document-builder.actions';

const QuestionHOC = (props) => {
  const { index, item, editQuestion, dispatch } = props;

  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: 'DocumentCard',
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }

      dispatch(resetIds());
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();

      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      dispatch(rearrangeItems(dragIndex, hoverIndex));

      item.index = hoverIndex;
    }
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'DocumentCard', id: item.position, index, originalIndex: index },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end: (dropResult, monitor) => {
      const { index, originalIndex } = monitor.getItem();
      const didDrop = monitor.didDrop();

      if (!didDrop) {
        dispatch(rearrangeItems(index, originalIndex));
      }
    }
  });

  const cssStyles = classNames({
    'bg-light': editQuestion === item.position
  });

  drag(drop(ref));

  return <div
    ref={ref}
    onClick={() => { dispatch(setEditQuestion(item)); }}
    style={{ cursor: 'move', opacity: isDragging ? 0 : 1 }}
    className={cssStyles}>
    {props.children}
  </div>
}

const mapStateToProps = (state) => {
  return {
    editQuestion: state.documentBuilder.editQuestion
  }
}

export default connect(mapStateToProps)(QuestionHOC);